<template>
<div id="id_about_us" style="min-height: 92vh;">
<a-row >  
    <a-col
      :md="24"
      :lg="24"
      :xs="24"
      :sm="24"
      style="max-width: 1500px; margin: auto"
    >
      <h3 class="text-center text-h1">{{$t('header.about')}}</h3>
      <div class="text-left text-h2">
        <p>
          {{$t('home.about.p1')}}
        </p>
        <p>
          {{$t('home.about.p2')}}
        </p>
      </div>
      <div class="text-left text-h2"></div>

      <div style="margin-top: 50px">
        <div class="text-h2">{{$t('home.about.address.title')}}</div>
        <div class="text-h3">{{$t('home.about.address.line1')}}</div>
        <div class="text-h3">{{$t('home.about.address.line2')}}</div>
        <div class="text-h3">{{$t('home.about.address.line3')}}</div>
      </div>
    </a-col>
  </a-row>
</div>
  
</template>

<script>
export default {
  name: "About",
};
</script>

<style scoped></style>
